/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
import { Spinner, Stack, Text } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Document } from "./Details";
import { getSiteIdentifier } from "@/helpers/siteIdentifierHelper";
import { getDocumentLink, getIsRedlined } from "@/helpers/fallback-response-helper";

const ComparedDetails = ({ graphToken }) => {
  const document = JSON.parse(sessionStorage.getItem("document"));
  const [baseVersion, setBaseVersion] = useState();
  const [reviseVersion, setReviseVersion] = useState();
  const [loading, setLoading] = useState(true);
  const [docToolTip, setDocToolTip] = useState(null);
  const [pdfToolTip, setPdfToolTip] = useState(null);

  useEffect(async () => {
    Office.context.document.getFilePropertiesAsync(async (context) => {
      axios
        .get(`https://addins.api.dexterity.legal/gateway/api/v1/compare/${document.id}`, {
          headers: {
            Authorization: `Bearer ${graphToken}`,
            "Site-Identifier": getSiteIdentifier(context.value.url),
            "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
          },
        })
        .then((response) => {
          let data = response.data.data;
          if (data) {
            setBaseVersion(data.baseDocument);
            setReviseVersion(data.revisedDocument);
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log("Error in compare details API", error);
          setLoading(false);
        });
    });
  }, [graphToken]);

  function getFullName(user) {
    let fullName = `${user.firstName} ${user.lastName}`;
    return fullName;
  }
  return (
    <Stack className="compareContainer">
      <Text className="compareHeadingText">Comparison Details</Text>
      {loading ? (
        <Spinner label={"Loading Comparision Details..."} />
      ) : (
        <>
          <Text className="compareSubHeadingText">Changed Version</Text>
          {reviseVersion && (
            <Document
              version={reviseVersion.version}
              folderName={reviseVersion.projectName}
              fileType={reviseVersion.fileType}
              isRedlined={getIsRedlined(reviseVersion)}
              sharedBy={reviseVersion?.shareDetails ? reviseVersion?.shareDetails?.reply : ""}
              sharedTo={reviseVersion?.shareDetails ? reviseVersion?.shareDetails?.replyAll : ""}
              fromName={reviseVersion?.shareDetails ? getFullName(reviseVersion?.shareDetails?.reply) : ""}
              toName={
                reviseVersion?.shareDetails
                  ? reviseVersion?.shareDetails?.replyAll.forEach((version) => getFullName(version))
                  : ""
              }
              lastUpdatedDate={reviseVersion.lastUpdatedDate}
              isCurrent={false}
              documentUrl={getDocumentLink(reviseVersion)}
              documentId={reviseVersion.id}
              emailNotes={reviseVersion?.shareDetails ? reviseVersion?.shareDetails?.emailNotes : ""}
              ischecked={true}
              isdisabled={true}
              index={0}
              docToolTip={docToolTip}
              setDocToolTip={setDocToolTip}
              pdfToolTip={pdfToolTip}
              setPdfToolTip={setPdfToolTip}
              receivedList={reviseVersion?.shareDetails?.replyAll?.filter(
                (user) => user?.userId !== reviseVersion?.shareDetails?.reply?.userId
              )}
              subject={reviseVersion?.shareDetails?.subject}
            />
          )}
          <Text className="compareSubHeadingText">Base Version</Text>
          {baseVersion && (
            <Document
              version={baseVersion.version}
              folderName={baseVersion.projectName}
              fileType={baseVersion.fileType}
              isRedlined={getIsRedlined(baseVersion)}
              sharedBy={baseVersion?.shareDetails ? baseVersion?.shareDetails?.reply : ""}
              sharedTo={baseVersion?.shareDetails ? baseVersion?.shareDetails?.replyAll : ""}
              fromName={baseVersion?.shareDetails ? getFullName(baseVersion?.shareDetails?.reply) : ""}
              toName={
                baseVersion?.shareDetails
                  ? baseVersion?.shareDetails?.replyAll.forEach((version) => getFullName(version))
                  : ""
              }
              lastUpdatedDate={baseVersion.lastUpdatedDate}
              isCurrent={false}
              documentUrl={getDocumentLink(baseVersion)}
              documentId={baseVersion.id}
              emailNotes={baseVersion?.shareDetails ? baseVersion?.shareDetails?.emailNotes : ""}
              ischecked={true}
              isdisabled={true}
              index={1}
              docToolTip={docToolTip}
              setDocToolTip={setDocToolTip}
              pdfToolTip={pdfToolTip}
              setPdfToolTip={setPdfToolTip}
              receivedList={baseVersion?.shareDetails?.replyAll?.filter(
                (user) => user?.userId !== baseVersion?.shareDetails?.reply?.userId
              )}
              subject={baseVersion?.shareDetails?.subject}
            />
          )}
        </>
      )}
    </Stack>
  );
};

export default ComparedDetails;
